import { useAuth } from '@lusha/auth-client-sdk';
import _ from 'lodash';
import { useMemo } from 'react';
function useIntercomCustomAttributes() {
    const { user } = useAuth();
    const { email } = user || {};
    const customAttributes = useMemo(() => {
        const obj = {
            app_id: envConfig.INTERCOM_APP_ID,
        };
        if (!email)
            return obj;
        obj.email = user.email;
        if (user.firstName || user.lastName) {
            obj.name = _.compact([user.firstName, user.lastName]).join(' ');
        }
        if (user === null || user === void 0 ? void 0 : user.intercom_jwt_token) {
            obj.intercom_user_jwt = user.intercom_jwt_token;
        }
        if (user.accountId && user.domain) {
            obj.company = {
                id: user.accountId,
                name: user.domain,
            };
        }
        return obj;
    }, [email]);
    return customAttributes;
}
export default useIntercomCustomAttributes;
